import React from 'react';
import { Button } from './ui/button';
import { MessageCircle } from 'lucide-react';
import { heroData } from '../data/mockData';
import { useFormModal } from './FormModalContext';

const HERO_IMAGE = "https://customer-assets.emergentagent.com/job_fridge-plants-b2b/artifacts/fer0yl80_geladeirabotom.png";

export const Hero = () => {
  const { openForm } = useFormModal();
  return (
    <section className="relative min-h-[92vh] flex items-center overflow-hidden bg-gradient-to-br from-pink-50 via-white to-rose-50 pt-32 md:pt-28 pb-16">
      {/* Decorative dotted pattern */}
      <div
        className="absolute inset-0 opacity-[0.04] pointer-events-none"
        style={{
          backgroundImage: 'radial-gradient(#eb068c 1.5px, transparent 1.5px)',
          backgroundSize: '24px 24px'
        }}
      ></div>

      {/* Decorative blobs */}
      <div className="absolute top-10 right-1/3 w-72 h-72 bg-[#eb068c]/10 rounded-full blur-3xl pointer-events-none"></div>
      <div className="absolute bottom-10 left-10 w-96 h-96 bg-[#25D366]/10 rounded-full blur-3xl pointer-events-none"></div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-8 items-center">

          {/* LEFT — Text 7/12 */}
          <div className="lg:col-span-7 text-center lg:text-left order-2 lg:order-1">

            <h1 className="!font-extrabold !text-4xl md:!text-5xl xl:!text-[3.75rem] md:!font-bold mb-6 text-gray-900 leading-[1.15] tracking-tight">
              Presente Premium<br />
              <span className="relative inline-block">
                <span className="relative z-10 text-[#eb068c]">Personalizado</span>
                <span className="absolute bottom-1 left-0 w-full h-3 bg-[#25D366]/25 -z-0 rounded"></span>
              </span><span className="text-[#eb068c]">.</span>
            </h1>

            <p className="text-lg md:text-xl text-gray-700 mb-8 leading-relaxed max-w-xl mx-auto lg:mx-0 font-medium">
              Sua marca <span className="text-[#178C41] font-bold">presente</span> todos os dias!
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start items-center mb-8">
              <Button
                size="lg"
                data-testid="hero-cta-form"
                onClick={openForm}
                className="bg-[#20BA5A] hover:bg-[#178C41] text-white px-8 py-6 text-lg font-semibold rounded-xl shadow-xl shadow-[#25D366]/30 hover:shadow-2xl hover:shadow-[#25D366]/40 transition-all duration-300 hover:scale-105 group">
                <MessageCircle className="mr-2 h-5 w-5 group-hover:rotate-12 transition-transform" />
                {heroData.cta}
              </Button>

              <div className="flex items-center gap-2 text-sm text-gray-500">
                <span className="flex -space-x-2">
                  <span className="w-9 h-9 rounded-full bg-white border-2 border-white shadow-md overflow-hidden flex items-center justify-center" title="Globo">
                    <img src="https://customer-assets.emergentagent.com/job_fridge-plants-b2b/artifacts/j9bk1xah_C%C3%B3pia%20de%20C%C3%B3pia%20de%20Design%20sem%20nome%20%281%29.png" alt="Globo" className="w-full h-full object-contain p-0.5" />
                  </span>
                  <span className="w-9 h-9 rounded-full bg-white border-2 border-white shadow-md overflow-hidden flex items-center justify-center" title="LG">
                    <img src="https://customer-assets.emergentagent.com/job_fridge-plants-b2b/artifacts/3fsbfec4_3.jpg" alt="LG" className="w-full h-full object-contain" />
                  </span>
                  <span className="w-9 h-9 rounded-full bg-white border-2 border-white shadow-md overflow-hidden flex items-center justify-center" title="Blindex">
                    <img src="https://customer-assets.emergentagent.com/job_fridge-plants-b2b/artifacts/8yiqge4c_5.jpg" alt="Blindex" className="w-full h-full object-contain" />
                  </span>
                </span>
                <span><strong className="text-gray-800">Milhares de plantinhas</strong> em todo o Brasil</span>
              </div>
            </div>

            {/* Feature pills */}
            <div className="flex flex-wrap justify-center lg:justify-start gap-2 pt-2">
              {heroData.features.map((feature, index) =>
                <span
                  key={index}
                  className="px-3 py-2 bg-white/95 backdrop-blur-sm rounded-lg text-pink-700 font-medium shadow-sm border border-pink-100 text-xs md:text-sm">
                  {feature}
                </span>
              )}
            </div>
          </div>

          {/* RIGHT — Image 5/12 with TV-frame treatment */}
          <div className="lg:col-span-5 relative order-1 lg:order-2">

            {/* Background accent square (offset) */}
            <div className="absolute -top-4 -right-4 w-full h-full bg-gradient-to-br from-[#eb068c] to-[#ff4ab8] rounded-3xl rotate-3 opacity-90 hidden lg:block"></div>
            <div className="absolute -bottom-4 -left-4 w-2/3 h-2/3 border-4 border-[#25D366] rounded-3xl -rotate-2 hidden lg:block"></div>

            {/* Image card */}
            <div className="relative rounded-3xl overflow-hidden shadow-2xl bg-white p-2">
              <div className="relative rounded-2xl overflow-hidden aspect-[4/5]">
                <img
                  src={HERO_IMAGE}
                  alt="Plantinhas de Geladeira personalizadas com logos de marcas como LG, Blindex, Renase, Softys e outras"
                  data-testid="hero-image"
                  className="absolute inset-0 w-full h-full object-cover"
                  style={{ objectPosition: 'center center' }}
                  loading="eager"
                />
              </div>
            </div>

          </div>

        </div>
      </div>
    </section>);

};
